import { Resolver, useForm } from 'react-hook-form';
import { TFatcaAdditionalInformation } from '~/modules/identification/forms/FatcaAdditionalInformation/types.ts';
import { useSelector } from 'react-redux';
import {
  selectFatcaAdditionalInformation,
  selectGeneralInfoFullNameEng,
  selectGeneralInfoFullNameUkr,
  selectGeneralInfoLegalResident,
} from '~/store/identification-form/selectors.ts';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { cloneDeep } from 'lodash';
import { FatcaAdditionalInformationValidationSchema } from '~/modules/identification/forms/FatcaAdditionalInformation/validationSchema.ts';
import { getFatcaAdditionalInformationInitialValues } from '~/modules/identification/forms/FatcaAdditionalInformation/utils.ts';

export const useFatcaAdditionalInformationForm = () => {
  const { isUSTaxResident, isForeignFinancialUnderFATCA, isControllingPersonUSTaxResident } =
    useSelector(selectGeneralInfoLegalResident) || {};
  const fullNameUkr = useSelector(selectGeneralInfoFullNameUkr);
  const fullNameEng = useSelector(selectGeneralInfoFullNameEng);
  const formData = useSelector(selectFatcaAdditionalInformation);

  const initialValues = getFatcaAdditionalInformationInitialValues(
    formData as TFatcaAdditionalInformation,
    fullNameUkr,
    fullNameEng
  );

  const schema = yup.lazy(() =>
    FatcaAdditionalInformationValidationSchema(
      isUSTaxResident,
      isForeignFinancialUnderFATCA,
      isControllingPersonUSTaxResident
    )
  );

  const form = useForm<TFatcaAdditionalInformation>({
    resolver: yupResolver(schema) as unknown as Resolver<TFatcaAdditionalInformation>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: cloneDeep(initialValues),
  });

  return form;
};
